// ...existing code...
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { trigger, transition, style, animate } from "@angular/animations";
import { SelectItem } from "primeng/api";
import { BreadcrumbService } from "src/app/breadcrumb.service";
import { Properties } from "../general/properties";
import { Router } from "@angular/router";
import { CertificatesService } from "src/app/_services/api_v1/certificates.service";
import { of } from "rxjs";

@Component({
    selector: "app-certificados",
    templateUrl: "./certificados.component.html",
    styleUrls: ["./certificados.component.css"],
    animations: [
        trigger("fadeIn", [
            transition(":enter", [
                style({ opacity: 0, transform: "scale(0.95)" }),
                animate(
                    "250ms ease-out",
                    style({ opacity: 1, transform: "scale(1)" })
                ),
            ]),
            transition(":leave", [
                animate(
                    "200ms ease-in",
                    style({ opacity: 0, transform: "scale(0.95)" })
                ),
            ]),
        ]),
    ],
})
export class CertificadosComponent implements OnInit {
    @ViewChild("modalBusqueda") modalBusquedaRef: ElementRef;
    @ViewChild("modalTipoCert") modalTipoCertRef: ElementRef;
    @ViewChild("modalGenerarCert") modalGenerarCertRef: ElementRef;
    constructor(
        private breadcrumbService: BreadcrumbService,
        private router: Router,
        private certificatesService: CertificatesService
    ) {
        const sessionData = JSON.parse(
            sessionStorage.getItem("access_token") || "{}"
        );
        if (!sessionData || !sessionData.user || !sessionData.user.brokerId) {
            this.router.navigate(["/home"]);
            return;
        }
        this.broker = sessionData.user.brokerId;
        this.brokerName = sessionData.user.brokerName;
        this.brokerEmail = sessionData.user.email;
    }
    // Datos de la respuesta exitosa para generación de certificado
    mensaje: string = "";
    planPagos: string = "";
    formaPago: string = "";
    saldoVencido: number = 0;
    tipoDocumento: string = "";
    nroDocumento: string = "";
    factura: number = 0;
    fecVencProxCuota: string = "";
    nroCuota: number = 0;
    totalCuotas: number = 0;
    nroPlanPago: number = 0;

    // Variables para card de Busqueda
    numeroPoliza: string = "";
    numeroEndoso: string = "";
    private broker: string = "";

    // Información del broker
    private brokerName: string = "";
    private brokerEmail: string = "";

    // Variables para card de Tipo de Certificado
    entFin: boolean = false;
    nombreEntFin: string = "";
    bloqueoDirecto: boolean = false;

    // Variables para card de Generar Certificado
    enviarCorreo: boolean = false;
    mailDestino: string = "";

    // Estado para validación y UI
    mostrarModalBusqueda: boolean = false;
    mostrarError: boolean = false;
    validacionExitosa: boolean = false;
    nombreContratante: string = "";
    camposBloqueados: boolean = false;
    mostrarContinuar: boolean = false;
    mostrarModalTipoCert: boolean = false;
    mostrarModalGenerarCert: boolean = false;
    mostrarPopupExito: boolean = false;
    mostrarErrorGeneracion: boolean = false;
    brokerNoPermitido: boolean = false;
    pagosPendientes: boolean = false;
    polizaNoVigente: boolean = false;

    properties: Properties = new Properties();

    // Opciones para dropdown de Sucursales
    sucursales: SelectItem[] = [
        { label: "---Seleccione Sucursal---", value: null },
        { label: "QUITO", value: 1 },
        {
            label: "GUAYAQUIL",
            value: 2,
        },
        {
            label: "CUENCA",
            value: 3,
        },
        {
            label: "MANTA",
            value: 4,
        },
        {
            label: "AMBATO",
            value: 5,
        },
        {
            label: "SANTO DOMINGO",
            value: 6,
        },
    ];
    sucursalSeleccionada: any = null;

    // Opciones para dropdown de ramos
    ramos: { label: string; value: number | null; title: string }[] = [
        { label: "---Seleccione Ramo---", value: null, title: "" },
        {
            label: "INCENDIO Y LINEAS ALIADAS",
            value: 1,
            title: "INCENDIO Y LINEAS ALIADAS",
        },
        { label: "TRANSPORTE ABIERTO", value: 2, title: "TRANSPORTE ABIERTO" },
        { label: "FIDELIDAD", value: 3, title: "FIDELIDAD" },
        { label: "VEHICULOS", value: 4, title: "VEHICULOS" },
        { label: "ROBO", value: 7, title: "ROBO" },
        {
            label: "FIEL CUMPLIMIENTO DE CONTRATO",
            value: 9,
            title: "FIEL CUMPLIMIENTO DE CONTRATO",
        },
        {
            label: "RESPONSABILIDAD CIVIL",
            value: 10,
            title: "RESPONSABILIDAD CIVIL",
        },
        {
            label: "TODO RIESGO CONTRATISTA",
            value: 11,
            title: "TODO RIESGO CONTRATISTA",
        },
        {
            label: "EQUIPO Y MAQUINARIA DE CONTRATISTAS",
            value: 13,
            title: "EQUIPO Y MAQUINARIA DE CONTRATISTAS",
        },
        { label: "RIESGOS ESPECIALES", value: 14, title: "RIESGOS ESPECIALES" },
        {
            label: "ROTURA DE MAQUINARIA",
            value: 15,
            title: "ROTURA DE MAQUINARIA",
        },
        { label: "GARANTIA ADUANERA", value: 17, title: "GARANTIA ADUANERA" },
        {
            label: "BUEN USO DE ANTICIPO",
            value: 18,
            title: "BUEN USO DE ANTICIPO",
        },
        { label: "EQUIPO ELECTRONICO", value: 20, title: "EQUIPO ELECTRONICO" },
        {
            label: "LUCRO CESANTE ROTURA MAQUINARIA",
            value: 22,
            title: "LUCRO CESANTE ROTURA MAQUINARIA",
        },
        { label: "GLOBAL BANCARIA", value: 24, title: "GLOBAL BANCARIA" },
        {
            label: "ACCIDENTES PERSONALES",
            value: 25,
            title: "ACCIDENTES PERSONALES",
        },
        {
            label: "TRANSPORTE ESPECIFICO",
            value: 28,
            title: "TRANSPORTE ESPECIFICO",
        },
        {
            label: "TRANSPORTE DE DINERO",
            value: 29,
            title: "TRANSPORTE DE DINERO",
        },
        { label: "TRANSPORTE INTERNO", value: 30, title: "TRANSPORTE INTERNO" },
        {
            label: "LUCRO CESANTE POR INCENDIO",
            value: 31,
            title: "LUCRO CESANTE POR INCENDIO",
        },
        {
            label: "EJECUCION DE OBRA Y BUENA CALIDAD DE MATERIALES",
            value: 34,
            title: "EJECUCION DE OBRA Y BUENA CALIDAD DE MATERIALES",
        },
        {
            label: "MULTIRIESGO INDUSTRIAL",
            value: 35,
            title: "MULTIRIESGO INDUSTRIAL",
        },
        { label: "MULTIRIESGO HOGAR", value: 36, title: "MULTIRIESGO HOGAR" },
        { label: "VIDA GRUPO", value: 50, title: "VIDA GRUPO" },
        {
            label: "ACCIDENTES PERSONALES BANCASEGUROS",
            value: 41,
            title: "ACCIDENTES PERSONALES BANCASEGUROS",
        },
        { label: "VIDA GRUPO C", value: 53, title: "VIDA GRUPO C" },
        { label: "ASISTENCIA MEDICA", value: 54, title: "ASISTENCIA MEDICA" },
    ];
    ramoSeleccionado: any = null;

    // Opciones para el dropdown de tipo de certificado
    tipoCert: string | null = null;

    get tipoCertificados() {
        const opciones = [
            { label: "Selecciona el certificado", value: null },
            { label: "Certificado de pago al día (General)", value: "general" },
        ];

        // Solo agregar la opción de póliza/endoso si bloqueoDirecto es false
        if (!this.bloqueoDirecto) {
            opciones.push({
                label: "Certificado de pago al día (Por póliza/endoso y/o plan de pagos)",
                value: "polizaEndoso",
            });
        }

        return opciones;
    }

    ngOnInit(): void {
        this.cargarBreadCrum();
        // Ordenar ramos alfabéticamente por label, manteniendo la opción nula al inicio
        if (this.ramos.length > 1) {
            const [primero, ...resto] = this.ramos;
            this.ramos = [
                primero,
                ...resto.sort((a, b) =>
                    a.label.localeCompare(b.label, "es", {
                        sensitivity: "base",
                    })
                ),
            ];
        }
    }

    cargarBreadCrum() {
        this.breadcrumbService.setItems([
            { label: "Inicio", routerLink: ["/home"] },
            { label: "Gestión de Cartera", routerLink: ["/#"] },
            { label: "Certificados de pago", routerLink: ["/certificados"] },
        ]);
    }

    // Lógica para llamado a la API y manejo de respuestas
    comprobarInfo() {
        // Construir el body de la petición
        const requestBody = {
            codSucursalBusqueda: this.sucursalSeleccionada,
            codRamo: this.ramoSeleccionado.value,
            nroPoliza: parseInt(this.numeroPoliza),
            nroEndoso: parseInt(this.numeroEndoso),
            nroDocumentoBroker: this.broker,
        };
        const validacion = this.certificatesService.validarDatos(requestBody);
        return validacion;
    }

    private handleValidationResponse(response: any) {
        if (response.respuesta === 0) {
            this.nombreContratante = response.contratante;
            this.mensaje = response.mensaje;
            this.planPagos = response.planPagos;
            this.formaPago = response.formaPago;
            this.saldoVencido = response.saldoVencido;
            this.tipoDocumento = response.tipoDocumento;
            this.nroDocumento = response.nroDocumento;
            this.factura = response.factura;
            this.fecVencProxCuota = response.fecVencProxCuota;
            this.nroCuota = response.nroCuota;
            this.totalCuotas = response.totalCuotas;
            this.nroPlanPago = response.nroPlanPago;
            this.validacionExitosa = true;
            this.camposBloqueados = true;
            this.mostrarContinuar = true;
        } else if (response.respuesta === 2007) {
            this.brokerNoPermitido = true;
        } else if (response.respuesta === 2011 || response.respuesta === 2012) {
            this.pagosPendientes = true;
        } else if (response.respuesta === 2013) {
            this.nombreContratante = response.contratante;
            this.mensaje = response.mensaje;
            this.planPagos = response.planPagos;
            this.formaPago = response.formaPago;
            this.saldoVencido = response.saldoVencido;
            this.tipoDocumento = response.tipoDocumento;
            this.nroDocumento = response.nroDocumento;
            this.factura = response.factura;
            this.fecVencProxCuota = response.fecVencProxCuota;
            this.nroCuota = response.nroCuota;
            this.totalCuotas = response.totalCuotas;
            this.nroPlanPago = response.nroPlanPago;
            this.validacionExitosa = true;
            this.camposBloqueados = true;
            this.mostrarContinuar = true;
            this.bloqueoDirecto = true;
        } else if (
            response.respuesta === 2008 ||
            response.respuesta === 2009 ||
            response.respuesta === 2010
        ) {
            this.polizaNoVigente = true;
        } else {
            this.mostrarError = true;
        }
    }

    private handleValidationError(error: any) {
        this.mostrarError = true;
    }

    // Lógica para validaciones y manejo de formularios
    // Verifica si todos los campos del formulario están completos
    get todosLosCamposCompletos(): boolean {
        return !!(
            this.sucursalSeleccionada &&
            this.ramoSeleccionado &&
            this.numeroPoliza &&
            this.numeroPoliza.trim() !== "" &&
            this.numeroEndoso &&
            this.numeroEndoso.trim() !== ""
        );
    }

    // Maneja el submit de la card de búsqueda
    onSubmit(form: any) {
        if (form.valid && !this.validacionExitosa) {
            this.comprobarInfo().subscribe(
                (response) => this.handleValidationResponse(response),
                (error) => this.handleValidationError(error)
            );
        }
    }

    // Lógica para abrir y cerrar modales
    abrirCardBusqueda(event?: MouseEvent) {
        this.mostrarModalBusqueda = true;
        setTimeout(() => {
            if (this.modalBusquedaRef && this.modalBusquedaRef.nativeElement) {
                this.modalBusquedaRef.nativeElement.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
        }, 0);
    }

    cerrarModalBusqueda(event: MouseEvent) {
        event.stopPropagation();
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
            this.limpiarDatosCards();
            this.mostrarModalBusqueda = false;
        }, 100);
    }

    cerrarModalTipoCert(event: MouseEvent) {
        event.stopPropagation();
        window.scrollTo({ top: 0, behavior: "smooth" });
        setTimeout(() => {
            this.limpiarDatosCards();
            this.mostrarModalTipoCert = false;
        }, 100);
    }

    // Acciones de PopUps
    cerrarPopupValidaciones(tipo: "broker" | "poliza" | "pagos") {
        if (tipo === "broker") this.brokerNoPermitido = false;
        if (tipo === "poliza") this.polizaNoVigente = false;
        if (tipo === "pagos") this.pagosPendientes = false;

        this.mostrarModalBusqueda = false;
        this.limpiarDatosCards();
    }

    redirectEstadoCuenta() {
        this.router.navigate(["/cuenta"]);
    }

    cerrarPopupError() {
        this.mostrarError = false;
        this.router.navigate(["/home"]);
    }

    reintentarValidacion() {
        this.mostrarError = false;
        this.comprobarInfo().subscribe(
            (response) => this.handleValidationResponse(response),
            (error) => this.handleValidationError(error)
        );
    }

    // Lógica para navegación entre tarjetas
    onContinuar() {
        this.mostrarModalBusqueda = false;
        this.mostrarModalTipoCert = true;
    }

    volverBuscar() {
        this.mostrarModalTipoCert = false;
        this.mostrarModalBusqueda = true;
        setTimeout(() => {
            if (this.modalBusquedaRef && this.modalBusquedaRef.nativeElement) {
                this.modalBusquedaRef.nativeElement.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                });
            }
        }, 0);
    }

    onContinuarGenCert(form?: any) {
        if (form && form.valid) {
            this.mostrarModalTipoCert = false;
            this.mostrarModalGenerarCert = true;
        }
    }

    volverTipoCert() {
        this.mostrarModalGenerarCert = false;
        this.mostrarModalTipoCert = true;
    }

    // Construye el objeto con todos los datos necesarios para el backend
    buildCertPayload() {
        const today = new Date();
        const pad = (n: number) => n.toString().padStart(2, "0");
        return {
            day: pad(today.getDate()),
            month: pad(today.getMonth() + 1),
            year: today.getFullYear().toString(),
            nombreInstitucion: this.nombreEntFin || "",
            nombreCliente: this.nombreContratante || "",
            tipoIdentificacion: this.tipoDocumento,
            identificacionCliente: this.nroDocumento,
            ramo: this.ramoSeleccionado.title || "",
            numPoliza: this.numeroPoliza || "",
            numEndoso: this.numeroEndoso || "",
            numFactura: this.factura || "",
            fechaVencimiento: this.fecVencProxCuota || "",
            numCuota: this.nroCuota || "",
            totalCuotas: this.totalCuotas || "",
            numPlanPagos: this.nroPlanPago || "",
            entFin: typeof this.entFin === "boolean" ? this.entFin : false,
            formaPago: this.formaPago || "",
            tipoCert: this.tipoCert || "",
            enviarCorreo: this.enviarCorreo,
            mailDestino: this.mailDestino || "",
            brokerId: this.broker,
            brokerName: this.brokerName,
            brokerEmail: this.brokerEmail,
        };
    }

    // Método que decide la acción según enviarCorreo
    onGenerarCertificado(form?: any) {
        if (form && form.valid) {
            // Construir el payload con todos los datos
            const requestBody = this.buildCertPayload();

            // Validar que los datos del template estén completos
            const isValidTemplate = this.validateTemplateData(
                requestBody.tipoCert,
                requestBody.entFin,
                requestBody.formaPago,
                requestBody
            );

            // Si la validación del template falla, detener el flujo
            if (!isValidTemplate) {
                return;
            }

            // Validar email si se va a enviar por correo
            if (requestBody.enviarCorreo && this.emailValidationError()) {
                return;
            }

            try {
                // Proceder con la generación del certificado
                if (requestBody.enviarCorreo == true) {
                    this.generarCertificado(requestBody);
                } else {
                    this.generarDescargarCertificado(requestBody);
                }
            } catch (error) {
                this.mostrarErrorGeneracion = true;
            }
        }
    }

    // Validación personalizada de correo electrónico
    emailValidationError(): string | null {
        if (!this.mailDestino) return null;
        const emails = this.mailDestino
            .split(";")
            .map((e) => e.trim())
            .filter((e) => e);
        if (emails.length === 0) return null;
        if (emails.length > 2)
            return "Solo se permiten hasta 2 correos electrónicos.";
        const emailRegex =
            /^([a-z0-9!#$%&'*+\-/=?^_`{|}~.]{1,100})@([a-z0-9!#$%&'*+\-/=?^_`{|}~]{1,255})\.([a-z]{2,})$/;
        for (const email of emails) {
            if (
                email.includes(" ") ||
                !email.includes("@") ||
                !emailRegex.test(email)
            ) {
                return "El correo electrónico ingresado no tiene el formato correcto.";
            }
            const [local, domain] = email.split("@");
            if (
                local.length > 100 ||
                domain.length > 255 ||
                local.startsWith(".") ||
                local.endsWith(".") ||
                domain.startsWith(".") ||
                domain.endsWith(".") ||
                /\.\./.test(email)
            ) {
                return "El correo electrónico ingresado no tiene el formato correcto.";
            }
            const tld = domain.split(".").pop();
            if (!tld || tld.length < 2) {
                return "El correo electrónico ingresado no tiene el formato correcto.";
            }
        }
        return null;
    }

    // Forzar minúsculas y bloquear espacios/caracteres no permitidos en el input
    onEmailInput(event: any) {
        let value = event.target.value;
        value = value.toLowerCase();
        value = value.replace(/\s+/g, "");
        value = value.replace(/[^a-z0-9!#$%&'*+\-/=?^_`{|}~@.;]/g, "");
        event.target.value = value;
        this.mailDestino = value;
    }

    generarDescargarCertificado(requestBody) {
        this.certificatesService.generarCertificado(requestBody).subscribe(
            (response: any) => {
                const downloadURL =
                    response && response.certificateUrl
                        ? response.certificateUrl
                        : null;
                if (downloadURL) {
                    fetch(downloadURL)
                        .then((res) => {
                            if (!res.ok)
                                throw new Error(
                                    "No se pudo descargar el certificado"
                                );
                            const filename =
                                response.certFileName || "certificado.pdf";
                            return res
                                .blob()
                                .then((blob) => ({ blob, filename }));
                        })
                        .then(({ blob, filename }) => {
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement("a");
                            link.href = url;
                            link.download = filename;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(url);
                            this.mostrarPopupExito = true;
                        })
                        .catch((err) => {
                            this.mostrarErrorGeneracion = true;
                        });
                } else {
                    this.mostrarErrorGeneracion = true;
                }
            },
            (error) => {
                this.mostrarErrorGeneracion = true;
            }
        );
    }

    // Método para generar y enviar el certificado
    generarCertificado(requestBody) {
        this.certificatesService.generarCertificado(requestBody).subscribe(
            (response: any) => {
                if (
                    response &&
                    (response.error ||
                        response.errorType ||
                        response.errorMessage)
                ) {
                    this.mostrarErrorGeneracion = true;
                } else {
                    this.mostrarPopupExito = true;
                }
            },
            (error) => {
                this.mostrarErrorGeneracion = true;
            }
        );
    }

    // Lógica para validaciones de inputs
    permitirSoloNumeros(event: KeyboardEvent) {
        const esNumero = /^[0-9]$/.test(event.key);
        const teclasControl = [
            "Backspace",
            "Tab",
            "ArrowLeft",
            "ArrowRight",
            "Delete",
            "Home",
            "End",
        ];
        if (
            esNumero ||
            teclasControl.includes(event.key) ||
            event.ctrlKey ||
            event.metaKey
        ) {
            return;
        }
        event.preventDefault();
    }

    // Bloquea letras y caracteres especiales al pegar
    onPasteSoloNumeros(event: ClipboardEvent) {
        let pastedInput = "";
        if (event.clipboardData) {
            pastedInput = event.clipboardData.getData("text");
        } else if ((window as any).clipboardData) {
            // Para compatibilidad con IE
            pastedInput = (window as any).clipboardData.getData("Text");
        }
        if (!/^\d*$/.test(pastedInput)) {
            event.preventDefault();
        }
    }

    // Convierte automáticamente a mayúsculas el nombre de la entidad financiera
    onInputUppercase(event: any) {
        const value = event.target.value;
        this.nombreEntFin = value.toUpperCase();
    }

    // Lógica para limpiar TODOS los datos ingresados en las tarjetas
    limpiarDatosCards() {
        // Limpiar datos de la card de búsqueda
        this.sucursalSeleccionada = null;
        this.ramoSeleccionado = null;
        this.numeroPoliza = "";
        this.numeroEndoso = "";
        this.validacionExitosa = false;
        this.nombreContratante = "";
        this.camposBloqueados = false;
        this.mostrarContinuar = false;

        // Limpiar datos de la card de tipo de certificado
        this.tipoCert = null;
        this.entFin = false;
        this.nombreEntFin = "";
        this.bloqueoDirecto = false;

        // Limpiar datos de la card de generación de certificado
        this.enviarCorreo = false;
        this.mailDestino = "";
    }

    reiniciarFlujo() {
        this.limpiarDatosCards();
        this.mostrarPopupExito = false;
        this.mostrarModalGenerarCert = false;
        this.abrirCardBusqueda();
    }

    // Función para validar que todos los datos necesarios para el template estén presentes
    private validateTemplateData(
        tipoCert: string | null,
        entFin: boolean,
        formaPago: string,
        data: any
    ): boolean {
        const errors: string[] = [];

        // Validar todos los tipos de campos
        this.validateBasicFields(data, errors);
        this.validateInstitucionField(entFin, data, errors);
        this.validatePolizaEndosoFields(tipoCert, formaPago, data, errors);

        // Si hay errores, mostrar popup de broker no permitido y retornar false
        if (errors.length > 0) {
            this.brokerNoPermitido = true;
            return false;
        }

        return true;
    }

    // Validar campos básicos comunes para todos los templates
    private validateBasicFields(data: any, errors: string[]): void {
        const basicFields = [
            "day",
            "month",
            "year",
            "nombreCliente",
            "tipoIdentificacion",
            "identificacionCliente",
        ];

        for (const field of basicFields) {
            if (!data[field] || String(data[field]).trim() === "") {
                errors.push(
                    `El campo '${field}' es requerido y no puede estar vacío.`
                );
            }
        }
    }

    // Validar campo de institución financiera
    private validateInstitucionField(
        entFin: boolean,
        data: any,
        errors: string[]
    ): void {
        // Validar nombreInstitucion solo para templates que incluyen "IF" (Institución Financiera)
        if (entFin) {
            if (
                !data.nombreInstitucion ||
                String(data.nombreInstitucion).trim() === ""
            ) {
                errors.push(
                    `El campo 'nombreInstitucion' es requerido para templates de Institución Financiera y no puede estar vacío.`
                );
            }
        }
    }

    // Validar campos específicos para templates de póliza/endoso
    private validatePolizaEndosoFields(
        tipoCert: string | null,
        formaPago: string,
        data: any,
        errors: string[]
    ): void {
        if (tipoCert === "polizaEndoso") {
            const polizaFields = [
                "ramo",
                "numPoliza",
                "numEndoso",
                "numFactura",
            ];

            for (const field of polizaFields) {
                if (!data[field] || String(data[field]).trim() === "") {
                    errors.push(
                        `El campo '${field}' es requerido para certificados de póliza/endoso y no puede estar vacío.`
                    );
                }
            }

            // Validar campos adicionales para templates de cuotas
            if (formaPago === "CUOTAS") {
                this.validateCuotasFields(data, errors);
            }
        }
    }

    // Validar campos específicos para cuotas
    private validateCuotasFields(data: any, errors: string[]): void {
        const cuotasFields = [
            "fechaVencimiento",
            "numCuota",
            "totalCuotas",
            "numPlanPagos",
        ];

        for (const field of cuotasFields) {
            if (!data[field] || String(data[field]).trim() === "") {
                errors.push(
                    `El campo '${field}' es requerido para certificados de cuotas y no puede estar vacío.`
                );
            }
        }
    }
}
